/**
 * 供应商 表单配置处理
 * @author welpher
 * @time 2021-12-28
 */
 export default {
  data () {
      return {
          formConfig: [{
              name: "客户级别名称",
              type: "ElInput",
              field: "level_name"
          }, {
              name: "计算系数",
              type: "ElInput",
              field: "price_coefficient"
          }, {
              name: "备注",
              type: "ElInput",
              field: "comment"
          }]
      }
  }
}